import { api } from '@/services'

export const list = () => {
    return api.get('/web/tag/list')
}